import React from 'react';
import { skills } from '../data/resume';
import './Skills.css';

export default function Skills() {
  return (
    <section id="skills" className="section-wrap">
      <h2 className="section-title">Skills</h2>
      <div className="skills-grid">
        {skills.map((group) => (
          <div className="skill-group" key={group.category}>
            <div className="skill-group-title mono">{group.category}</div>
            <div className="skill-list">
              {group.items.map((item) => (
                <span className="skill-chip mono" key={item}>{item}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
